export default "__VITE_ASSET__ea7bd471__"